<div class="fixed bottom-4 z-50 flex justify-center pointer-events-none left-60 right-4">
  <div
    class="pointer-events-auto flex flex-row items-center gap-(--gap-relaxed) border border-(--border) bg-(--surface-0) p-(--space-3) rounded-(--radius-lg) shadow-lg">
    <ng-content />
  </div>
</div>
